import { useQuery } from 'react-query';
import { projectsQueryKeys } from './query-keys';
import { ProjectsAPI } from '../apis';
import { AxiosResponse } from 'axios';
import { CommentType } from '@buildwise/pages/article/hooks/useArticleDetailsQuery';
import { useMemo } from 'react';

function useActivityLogQuery({
  companyId,
  objectId,
}: {
  companyId: string;
  objectId: string;
  shouldFetch?: boolean;
}) {
  const { data: activityLogData, ...rest } = useQuery<
    AxiosResponse<{
      comments: CommentType[];
      commentsCount: number;
      companyId: string;
    }>
  >({
    queryKey: projectsQueryKeys.getActivityLog({ companyId, objectType: 'PROJECT_NOTES' }),
    queryFn: () =>
      ProjectsAPI.getActivityLog({
        companyId,
        objectType: 'ActivityLog',
        objectId,
        objectName: 'PROJECT',
      }),
    keepPreviousData: true,
    enabled: !!companyId,
  });

  const activityLog = useMemo(
    () =>
      activityLogData?.data.comments && Array.isArray(activityLogData?.data.comments)
        ? activityLogData?.data.comments
        : [],
    [activityLogData],
  );

  return {
    activityLog,
    ...rest,
  };
}

export default useActivityLogQuery;
